import { useAuthStore } from "@/stores/auth";
import { useBillingStore } from "@/stores/billing";

export default defineNuxtRouteMiddleware(async () => {
  const authStore: any = useAuthStore();
  const billingStore = useBillingStore();
  const localePath = useLocalePath();

  if (!authStore.loggedIn || !authStore.user || authStore.user.role !== "customer-admin") {
    return;
  }

  await billingStore.refreshFeatureFlags();

  if (billingStore.hasEnergyMonitoringAccess) {
    if (process.server) {
      return;
    }

    const response = await fetchSmartDodosSsoLink("/dashboard");

    if (!response.error && response.data?.redirect_url) {
      return navigateTo(response.data.redirect_url, { external: true });
    }

    return;
  }

  if (
    billingStore.energyMonitoringConnectionSize
    && !billingStore.hasEnergyMonitoringAccess
  ) {
    return navigateTo(`${localePath("/dashboard/billing")}#energy-monitoring-addon`);
  }
});
